import { actionTypes } from './types';

type Action<T> = import('./types').Action<T>;
type LoadConfig = import('../reducers/context').ContextReducer;

export interface LoadConfigAction extends Action<typeof actionTypes.LOAD_CONFIG> {
    type: typeof actionTypes.LOAD_CONFIG;
    payload: {
        config: LoadConfig['config'];
        localConfigData: LoadConfig['localConfigData'];
        appType: LoadConfig['appType'];
    };
}
export interface ShowDialogAction extends Action<typeof actionTypes.SHOW_DIALOG> {
    type: typeof actionTypes.SHOW_DIALOG;
}

export type LoadConfigActions = LoadConfigAction | ShowDialogAction;

export const loadConfig = (
    config: LoadConfig['config'],
    localConfigData: LoadConfig['localConfigData'],
    appType: LoadConfig['appType'],
): LoadConfigAction => ({
    type: actionTypes.LOAD_CONFIG,
    payload: { config, localConfigData, appType },
});

export const showDialog = (): ShowDialogAction => ({
    type: actionTypes.SHOW_DIALOG,
});

export default { loadConfig };
